import { SpacingToken } from '@optimus-web/common';

export const DEFAULT_ACCORDION_SPACING: SpacingToken = '200';

export const DEFAULT_PADDINGS = {
    top: '100',
    bottom: '100',
    left: '200',
    right: '200',
} as const;
